var map;
var InfoObj = [];

var icons = {
  adoc:{
    icon: 'https://cdn.shopify.com/s/files/1/0346/1893/3307/files/logo_adoc-min.png?v=1655323909'
  }
};

var markersOnMap = [
  {
    storecode: 'A01',
    placeName: 'ADOC City Mall',
    storeAddress: 'CC City Mall, Local 1091, Alajuela',
    schedule: 'Lunes a Sábado: 10:00am a 9:00pm<br>Domingo: 10:00am a 8:00pm',
    phone: '42005215',
    whatsapp: '61837360',
    page: 'https://goo.gl/maps/j6W1Bd9vpKhJ5rbP8',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 10.0041086,
      lng: -84.2113861
    }],
    type: 'adoc'
  },
  {
    storecode: 'A02',
    placeName: 'ADOC Multicentro Desamparados',
    storeAddress: 'CC Mall Multicentro Desamparados, Locales F02 y 03, Desamparados',
    schedule: 'Lunes a Sábado: 10:00am a 9:00pm<br>Domingo: 10:00am a 7:00pm',
    phone: '22591848',
    whatsapp: '60152240',
    page: 'https://g.page/r/CV7-BLRWS-JOEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.8995811,
      lng: -84.0685204
    }],
    type: 'adoc'
  },
  {
    storecode: 'A03',
    placeName: 'ADOC Catedral, ',
    storeAddress: '50 mts al oeste de Parque San Isidro del General, Calle Central, San José',
    schedule: 'Lunes a Sábado: 10:00am a 8:00pm<br>Domingo: 10:00am a 6:00pm',
    phone: '22260960',
    whatsapp: '60152240',
    page: 'https://g.page/r/CaW6PuMpQGhqEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.9171365,
      lng: -84.0714491
    }],
    type: 'adoc'
  },
  {
    storecode: 'A11',
    placeName: 'ADOC Av. Central',
    storeAddress: 'San José, Contiguo A Librería Lehman, Av Central. C 1 Y 3',
    schedule: 'Lunes a Sábado: 8:30am a 7:00pm<br>Domingo: 9:00am a 6:00pm',
    phone: '22214985',
    whatsapp: '60152240',
    page: 'https://g.page/r/CaW6PuMpQGhqEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.9339805,
      lng: -84.0779266
    }],
    type: 'adoc'
  },
  {
    storecode: 'A21',
    placeName: 'ADOC 2a Av',
    storeAddress: 'San José, Contiguo a Condominio Las Américas, C 6 Y Ave. 2da.',
    schedule: 'Lunes a Sábado: 8:30am a 7:00pm<br>Domingo: 9:00am a 6:00pm',
    phone: '22214373',
    whatsapp: '60152240',
    page: 'https://g.page/r/CaW6PuMpQGhqEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.9334282,
      lng: -84.0815765
    }],
    type: 'adoc'
  },
  {
     storecode: 'A22',
     placeName: 'ADOC San Ramon',
     storeAddress: '',
     schedule: 'Lunes a Sábado: 9:30am a 7:00pm<br>Domingo: 9:00am a 5:00pm',
     phone: '61743605',
     whatsapp: '61743605',
     page: 'https://g.page/r/CV0IfAABWMqtEBA',
     review: '',
     zona: 1,
     LatLng: [{
       lat: 10.5388772,
       lng: -84.582165000000003
     }],
     type: 'adoc'
   },
  {
    storecode: 'A23',
    placeName: 'ADOC Perez Zeledon',
    storeAddress: '50 mts al oeste de Parque San Isidro del General, Calle Central, San José',
    schedule: 'Lunes a Sábado: 9:30am a 7:00pm<br>Domingo: 9:00am a 5:00pm',
    phone: '64637614',
    whatsapp: '64637614',
    page: 'https://g.page/r/CV0IfAABWMqtEBA',
    review: '',
    zona: 1,
    LatLng: [
      {
        lat: 9.3746389,
        lng: -83.703777
      }
    ],
    type: 'adoc'
  },
  {
    storecode: 'A24',
    placeName: 'ADOC CC El Encuentro San Carlos',
    storeAddress: 'CC El Encuentro, Local N02-L06-05, Ciudad Quesada, San Carlos, Alajuela',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '70999586',
    whatsapp: '60152240',
    page: 'https://g.page/r/CV0IfAABWMqtEBA',
    review: '',
    zona: 1,
    LatLng: [
      {
        lat: 10.342158463278109,
        lng: -84.43082180101568
      }
    ],
    type: 'adoc'
  },
  {
    storecode: 'A26',
    placeName: 'ADOC Oxígeno',
    storeAddress: 'CC Oxígeno, Local 20309, Heredia',
    schedule: 'Lunes a Sábado: 10:00am a 9:00pm<br>Domingo: 10:00am a 8:00pm',
    phone: '22295047',
    whatsapp: '60152240',
    page: 'https://g.page/r/CQtSU9m3JZa6EBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.9938817,
      lng: -84.1311392
    }],
    type: 'adoc'
  },
  {
    storecode: 'A40',
    placeName: 'ADOC Metrocentro Cartago',
    storeAddress: 'Cartago, CC Metrocentro, Local 43 Y 44',
    schedule: 'Lunes a Sábado: 10:00am a 8:00pm<br>Domingo: 10:00am a 7:00pm',
    phone: '25915042',
    whatsapp: '60152240',
    page: 'https://g.page/r/CQtSU9m3JZa6EBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.8676018,
      lng: -83.9303921
    }],
    type: 'adoc'
  },
  {
    storecode: 'A43',
    placeName: 'ADOC Multiplaza Escazú',
    storeAddress: 'CC Multiplaza Escazú, 1r Nivel, Local 158-59',
    schedule: 'Lunes a Sábado: 10:00am a 9:00pm<br>Domingo: 10:00am a 8:00pm',
    phone: '22016241',
    whatsapp: '60152240',
    page: 'https://g.page/r/Cem0PcMaBSVmEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.9452411,
      lng: -84.1517576
    }],
    type: 'adoc'
  },
  {
    storecode: 'A52',
    placeName: 'ADOC Paseo de las Flores',
    storeAddress: 'CC Paseo de las Flores, 3a Etapa, Local 31A, Heredia',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '22625280',
    whatsapp: '60152240',
    page: 'https://g.page/r/CeK7cW-q-1lOEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.9850812,
      lng: -84.1121662
    }],
    type: 'adoc'
  },
  {
    storecode: 'A53',
    placeName: 'ADOC Multiplaza del Este',
    storeAddress: 'CC Multiplaza del Este, 1r Nivel, Local 16',
    schedule: 'Lunes a Sábado: 10:00am a 9:00pm<br>Domingo: 10:00am a 8:00pm',
    phone: '22345598',
    whatsapp: '60152240',
    page: 'https://g.page/r/CV0IfAABWMqtEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.9179043,
      lng: -84.0470634
    }],
    type: 'adoc'
  },
  {
    storecode: 'A55',
    placeName: 'ADOC Paseo Metropoli',
    storeAddress: 'CC Metropoli, locales 1509 y 1510"L", Cartago',
    schedule: 'Lunes a Sábado: 10:00am a 8:00pm<br>Domingo: 10:00am a 7:00pm',
    phone: '60233328',
    whatsapp: '60152240',
    page: 'https://g.page/r/CV0IfAABWMqtEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.8674749,
      lng: -83.9431724
    }],
    type: 'adoc'
  },
  {
    storecode: 'A56',
    placeName: 'ADOC Liberia',
    storeAddress: 'Plaza 25 de Julio IPB frente Almacenes El Rey, Liberia, Guanacaste',
    schedule: 'Lunes a Sábado: 9:00am a 6:00pm<br>Domingo: 9:00am a 5:00pm',
    phone: '70909380',
    whatsapp: '70909380',
    page: 'https://g.page/r/CV0IfAABWMqtEBA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 10.628079,
      lng: -85.441164
    }],
    type: 'adoc'
  }
];  

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo(){
  for(var i=0; i < markersOnMap.length; i++){
    var contentString = '<div class="place-name">' + markersOnMap[i].placeName + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
    if(markersOnMap[i].phone !== "")
    	contentString += '<div class="place-link"><a class="place-link" href="tel:+mapa'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%"> (mapa)'+ markersOnMap[i].phone + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=mapa'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%"> (mapa)' + markersOnMap[i].whatsapp + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
    if(markersOnMap[i].page !== "")
    	contentString += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
    if(markersOnMap[i].review !== "")
    contentString += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });


    marker.addListener('click', function(){
      closeOtherInfo();
      infowindow.open(marker.get('map'),marker);
      InfoObj[0] = infowindow;
    });
    
    switch (markersOnMap[i].zona) {
      case 1: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
      case 2: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info2").innerHTML += contentDiv;
        		break;
      
      case 3: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info3").innerHTML += contentDiv;
        		break;
      
      case 4: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info4").innerHTML += contentDiv;
        		break;
      
      default:
      			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="ADOC Costa Rica" style="width: 6%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="ADOC Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
    }
  }
}

function closeOtherInfo(){
  if(InfoObj.length > 0){
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon){
  var centerStore = {lat: posLat, lng: posLon};
  map.setCenter(centerStore);
}

function positionOk(pos){
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = {lat: latitudeMap, lng: longitudMap};
  map.setCenter(centerStore);
}

function positionKO(){
  const centerStore = {lat: 9.9452411, lng: -84.1517576};
  map.setCenter(centerStore);
}

function initMap(){
  map = new google.maps.Map(document.getElementById('map'),{
    zoom: 15,
    center: {lat: 9.9452411, lng: -84.1517576},
    mapId: '7b2b8c05c9abdb62'
  });

  if(navigator.geolocation){
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);            
  }

  addMarkerInfo();
};

function openPage(pageName,elmnt) {
  var i, tabcontent;
  
  tabcontent = document.getElementsByClassName("tabcontent2");
  
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  };
    
  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}